import React from "react";

export default function Calculator() {
  return (
    <>
      <div>
        <iframe
          title="carbon-footprint calculator"
          width="100%"
          height="600px"
          frameborder="0"
          marginwidth="0"
          marginheight="0"
          src="https://calculator.carbonfootprint.com/calculator.aspx"
        ></iframe>
      </div>
    </>
  );
}
